import { useEffect, useState } from 'react';

interface Props {
    label?: string;
    name: string;
    value?: string | null;
    onChange: (value: string | null) => void;
    disabled?: boolean;
    textFormat?: 'YYYYMMDD' | 'YYYY-MM-DD';
}

export const InputDateYYYYMMDD = ({
    label,
    name,
    value,
    onChange,
    disabled = false,
    textFormat = 'YYYY-MM-DD'
}: Props) => {
    const [uiDate, setUiDate] = useState<string>('');

    useEffect(() => {
        if (!value) {
            setUiDate('');
            return;
        }

        if (value.includes('-')) {
            setUiDate(value);
            return;
        }

        if (value.length === 8) {
            const yyyy = value.substring(0, 4);
            const mm = value.substring(4, 6);
            const dd = value.substring(6, 8);
            setUiDate(`${yyyy}-${mm}-${dd}`);
        }
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const v = e.target.value;

        if (!v) {
            setUiDate('');
            onChange(null);
            return;
        }

        setUiDate(v);

        if (textFormat === 'YYYYMMDD') {
            onChange(v.replace(/-/g, ''));
        } else {
            onChange(v);
        }
    };

    return (
        <>
            {label && <label>{label}</label>}
            <input
                type="date"
                className="form-control"
                name={name}
                value={uiDate}
                disabled={disabled}
                onChange={handleChange}
            />
        </>
    );
};
